import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import TextSmallSize from '../text-small-size/text-small-size.component';
import CompletionBar from '../completion-bar/completion-bar.component';
import TextBlock from '../text-block/text-block.component';
import FormatService from '../../services/format-service';
import useStylesCompletionBlock from './completion-block.styles';

const CompletionBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    withText,
    withPostfix,
    withNoProgressBar,
    withRightOffset,
    headerText,
    itemsTotal,
    completedItemsTotal,
  } = props;

  const { classes } = useStylesCompletionBlock();

  const rightOffsetClassName: string | undefined = withRightOffset ? classes.completionRightOffset : undefined;
  const progressBottomClassName: string | undefined = withText ? classes.completionBlockProgressBottom : undefined;
  const progressLeftClassName: string | undefined = withPostfix ? classes.completionBlockProgressLeft : undefined;

  const progressValue: number = itemsTotal ? (completedItemsTotal / itemsTotal) * 100 : 0;
  const progressLabel: string = `(${completedItemsTotal} / ${itemsTotal}) complete`;

  return (
    <FlexContainer
      isInline
      isEnd={withPostfix}
      isColumn={withText}
      className={FormatService.formatClassNames(classes.completionBlock, rightOffsetClassName)}
    >
      {
        withText && (
          <FlexContainer isSpread>
            {
              !!headerText && (
                <TextSmallSize>
                  {headerText}
                </TextSmallSize>
              )
            }
            {
              !!itemsTotal && (
                <TextSmallSize className={classes.completionBlockTotal}>
                  {progressLabel}
                </TextSmallSize>
              )
            }
          </FlexContainer>
        )
      }
      {
        !withNoProgressBar && (
          <TextBlock
            className={FormatService.formatClassNames(
              classes.completionBlockProgress, progressBottomClassName, progressLeftClassName,
            )}
          >
            <CompletionBar value={progressValue} />
          </TextBlock>
        )
      }
      {
        withPostfix && (
          <TextBlock>
            {progressLabel}
          </TextBlock>
        )
      }
    </FlexContainer>
  );
});

export default CompletionBlock;
